import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { CloseOutlined } from '@ant-design/icons';
import { WordItem } from '@/types';
import './index.less';
import { addNewWordToList, getWordStatus } from '@/apis';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';

interface IProps {
    closed: () => void;
    wordItem: WordItem;
    position: { x: number; y: number };
    visible: boolean;
    questionId: number;
}

const NewWordCard: React.FC<IProps> = props => {
    const { t } = useTranslation();
    
    const wordRef = useRef<any>();
    const { closed, wordItem, visible, position, questionId } = props;
    const [calcPosition, setCalcPosition] = useState<{ x: number; y: number }>({
        x: 0,
        y: 0,
    });
    const [wordStatus, setWordStatus] = useState(0);

    const rePostion = () => {
        const activeWidth = wordRef.current?.offsetWidth || 288;
        // const activeHeight = wordRef.current?.offsetHeight || 220;
        const clientWidth = document.documentElement.clientWidth;
        // const clientHeight = document.documentElement.clientHeight;
        const top: number = position.y + 20;
        let left: number = position.x;
        // //右边界处理
        const right = clientWidth - left;
        // console.log(activeWidth );
        if (activeWidth > right) {
            left = clientWidth - activeWidth - 10;
        }
        // //下边界处理
        // let bottom = clientHeight - top;
        // if (activeHeight > bottom) {
        //     top = clientHeight - activeHeight - 10;
        // }
        setCalcPosition({
            x: left,
            y: top,
        });
    };

    const reqWordStatus = async () => {
        const ret = await getWordStatus(wordItem.wordId, wordItem.projectId);
        if (ret.status === 0) {
            setWordStatus(ret.result ? 1 : 0);
        }
    };

    useEffect(() => {
        closed();
    }, [questionId]);

    useEffect(() => {
        if (visible) {
            rePostion();
            reqWordStatus();
        }
    }, [wordItem?.wordId, visible]);

    const addNewWord = async () => {
        const ret = await addNewWordToList({
            wordId: wordItem.wordId,
            projectId: wordItem.projectId,
        });
        if (ret.status === 0) {
            message.success(t('vocabulary.addSuccess'));
            setWordStatus(1);
        }
    };

    return wordItem
        ? ReactDOM.createPortal(
              <div
                  className="sub-tiku__tiku-quesiton-new-word"
                  ref={wordRef.current}
                  style={{
                      display: visible ? 'block' : 'none',
                      top: calcPosition.y,
                      left: calcPosition.x,
                  }}
              >
                  <CloseOutlined onClick={closed} />
                  <div className="sub-tiku__question-eg-title">{wordItem.englishWord}</div>
                  <div className="sub-tiku__question-ch-title">{wordItem.chineseWord}</div>
                  {wordItem.chineseSubtitle && <div className="sub-tiku__question-descriptions">{wordItem.chineseSubtitle}</div>}
                  <div className="sub-tiku__new-word-btn-box">
                      {wordStatus === 0 ? (
                          <div className="sub-tiku__tiku-default-btn sub-tiku__tiku-plain-btn" onClick={addNewWord}>
                              {t('vocabulary.addToNotebook')}
                          </div>
                      ) : (
                          <div className="sub-tiku__tiku-default-btn sub-tiku__disabled">{t('vocabulary.addedToNotebook')}</div>
                      )}
                  </div>
              </div>,
              document.body
          )
        : null;
};

export default NewWordCard;
